module.exports = __webpack_public_path__ + "static/media/promo1.0dafa667.jpg";